<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      @row-save="saveOrder"
      @row-update="updateOrder"
      @row-del="deleteOrder"
      :row-style="rowStyle"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
      <template slot="serviceProcess" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.serviceProcess }}
        </div>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getOnlineWorkOrder, saveOrUpdateOnlineWorkOrder, deleteOnlineWorkOrder, getOnlineDepartment } from '@/api/health/manage'

export default {
  data() {
    return {
      channel: window.localStorage.getItem('channel'),
      params: {
        // channel: window.localStorage.getItem("channel"),
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: '序号',
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        editBtn: true,
        addBtn: true,
        delBtn: true,
        // selection: true,
        // dialogWidth: "40%",
        labelWidth: 120,
        menuWidth: 150, // 初始宽度
        column: [
          {
            label: '时间安排及提醒',
            prop: 'date',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 130
          },
          {
            label: '项目类别',
            prop: 'type',
            type: 'select',
            filterable: true,
            clearable: true,
            allowCreate: true,
            defaultFirstOption: true,
            search: true,
            dicData: [
              { label: '设备安装', value: '设备安装' },
              { label: 'VIP健康管理服务', value: 'VIP健康管理服务' },
              { label: '三甲绿色助医', value: '三甲绿色助医' },
              { label: '线下B端用户活动', value: '线下B端用户活动' },
              { label: '体检', value: '体检' }
            ],
            width: 130
          },
          {
            label: '项目名称',
            prop: 'name',
            search: true,
            width: 120
          },
          {
            label: '物料准备',
            prop: 'material',
            search: true,
            width: 130
          },
          {
            label: '主责部门',
            prop: 'department',
            search: true,
            type: 'cascader',
            dicData: [
              { label: '健管部', value: '健管部', children: [] },
              { label: '技术部', value: '技术部', children: [] },
              { label: '行政部', value: '行政部' },
              { label: '医务部', value: '医务部' }
            ],
            width: 120,
            filterable: true,
            clearable: true,
            allowCreate: true,
            defaultFirstOption: true
          },
          {
            label: ' 服务人员确认',
            prop: 'serviceStaff',
            type: 'select',
            search: true,
            searchLabelWidth: 100,
            dicData: [
              { label: '大白客服', value: '大白客服' },
              { label: '健管护士', value: '健管护士' },
              { label: '健管护师', value: '健管护师' }
            ],
            width: 120
          },
          {
            label: '协同部门',
            prop: 'follow',
            search: true,
            type: 'cascader',
            dicData: [
              { label: '健管部', value: '健管部', children: [] },
              { label: '技术部', value: '技术部', children: [] },
              { label: '行政部', value: '行政部' },
              { label: '医务部', value: '医务部' }
            ],
            width: 120,
            filterable: true,
            clearable: true,
            allowCreate: true,
            defaultFirstOption: true
          },
          {
            label: '服务流程',
            prop: 'serviceProcess',
            search: true,
            type: 'textarea',
            slot: true
          },
          {
            label: '发起人',
            prop: 'creator',
            search: true,
            width: 80
          },
          {
            label: '整改汇总',
            prop: 'rectification',
            type: 'textarea'
          }
          // {
          //   label: "状态",
          //   prop: "status",
          //   search: true,
          //   width: 80,
          //   type: "select",
          //   dicData: [
          //     { label: "未完成", value: "0" },
          //     { label: "已完成", value: "1" },
          //   ],
          //   width: 80,
          // },
        ]
      },
      data: []
    }
  },
  mounted() {
    getOnlineDepartment('健管部', this.channel).then(res => {
      this.option.column[4].dicData[0].children = res.data
      this.option.column[6].dicData[0].children = res.data
    })
    getOnlineDepartment('技术部', this.channel).then(res => {
      this.option.column[4].dicData[1].children = res.data
      this.option.column[6].dicData[1].children = res.data
    })
  },
  computed: {},
  methods: {
    onLoad(page, params) {
      params.channel = window.localStorage.getItem('channel')
      getOnlineWorkOrder(page.currentPage, page.pageSize, params).then(res => {
        this.page.total = res.data.total
        this.data = res.data.workOrder
      })
    },

    saveOrder(row, done, loading) {
      if (row.follow !== undefined) {
        row.follow = row.follow[0] + ',' + row.follow[1]
      }
      if (row.department !== undefined) {
        row.department = row.department[0] + ',' + row.department[1]
      }
      row.channel = window.localStorage.getItem('channel')
      saveOrUpdateOnlineWorkOrder(row)
        .then(res => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('添加成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    updateOrder(row, index, done, loading) {
      // row.channel = window.localStorage.getItem("channel");
      console.log(row.follow)
      if (row.follow !== undefined && Array.isArray(row.follow)) {
        row.follow = row.follow[0] + ',' + row.follow[1]
      }
      if (row.department !== undefined && Array.isArray(row.department)) {
        row.department = row.department[0] + ',' + row.department[1]
      }
      console.log(row.follow)
      saveOrUpdateOnlineWorkOrder(row)
        .then(res => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('修改成功!')
        })
        .catch(res => {
          this.$message.error('修改失败!')
          this.onLoad(this.page, this.params)
        })
    },

    deleteOrder(row, done, loading) {
      deleteOnlineWorkOrder(row)
        .then(res => {
          done()
          this.onLoad(this.page, this.params)
          this.$message.success('删除成功!')
        })
        .catch(() => {
          this.onLoad(this.page, this.params)
        })
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem('channel')
      }
      this.onLoad(this.page, this.params)
    },

    searchChange(params, done) {
      params.channel = window.localStorage.getItem('channel')
      this.params = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    },

    rowStyle({ row, rowIndex }) {
      if (row.status === 1) {
        return {
          color: 'red'
        }
      }
      // return {
      //   color: "#1890ff",
      // };
    }
  }
}
</script>
<style>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
